import {
    UNIONLISTAGENTFORPARTNER_SUCCESS,
    UNIONLISTAGENTFORPARTNER_FAILED,
    RESET_UNIONLISTAGENTFORPARTNER,
    LOADING_UNIONLISTAGENTFORPARTNER,
    NETWORK_ERROR_UNIONLISTAGENTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetUNIONLISTAGENTFORPARTNER = () => {
    return { type: RESET_UNIONLISTAGENTFORPARTNER };
};

const partnerUnionListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UNIONLISTAGENTFORPARTNER });
    await partnerServices
        .post("unionList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerUnionListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerUnionListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_UNIONLISTAGENTFORPARTNER,
                payload: err
            });
        });
};

function partnerUnionListReqsuccess(data) {
    return {
        type: UNIONLISTAGENTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerUnionListReqFailed(data) {
    return {
        type: UNIONLISTAGENTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetUNIONLISTAGENTFORPARTNER, partnerUnionListReq }